<template>
  <g class="custom-label">
    <rect x="0" y="0" height="20" :width="labelWidth + 4" fill="white" v-if="line1 || line2" stroke="#dcdcdc" stroke-width=".5"/>
    <text v-if="line1 !== '' && !line2"
      style="overflow: hidden" 
      ref="line1" 
      fill="#b3b3b3" 
      font-size=".75rem"
      x="2" y="14">{{ line1 }}</text>
    <text v-if="line2 !== '' && !line1"
      style="overflow: hidden" 
      ref="line2  " 
      fill="#b3b3b3" 
      font-size=".75rem"
      x="2" y="14">{{ line2 }}</text>
    <text v-if="line1 !== '' && line2 !== ''"
      style="overflow: hidden" 
      ref="line1" 
      fill="#b3b3b3" 
      font-size=".5rem"
      x="2" y="9">{{ line1 }}</text>
    <text v-if="line1 !== '' && line2 !== ''"
      style="overflow: hidden" 
      ref="line2" 
      fill="#b3b3b3" 
      font-size=".5rem"
      x="2" y="18">{{ line2 }}</text>
  </g>
</template>

<script>
export default {
  props: {
    line1: String,
    line2: String,
  },
  data () {
    return {
      labelWidth: 0
    }
  },
  methods: {
    handleLabelSize () {
      let widthLine1 = this.$refs.line1 ? this.$refs.line1.getBBox().width : 0
      let widthLine2 = this.$refs.line2 ? this.$refs.line2.getBBox().width : 0
      
      let width = Math.max(widthLine1, widthLine2)
      // console.log(width,  widthLine1, widthLine2)
      this.labelWidth = width
      this.$emit('custom-label-width', width)
    }
  },
  watch: {
    line1 () {
      this.$nextTick(() => {
        this.handleLabelSize()
      })
    },
    line2 () {
      this.$nextTick(() => {
        this.handleLabelSize()
      })
    }
  },
  mounted () {
    this.handleLabelSize()
  }
}
</script>

<style>

</style>
